'use client';

import { c as _c } from "react/compiler-runtime";
import type { OnboardingFlow } from '../config';
import { OnboardingProvider } from './onboarding-context';
import { OnboardingHeader } from './onboarding-header';
import { StepRenderer } from './step-renderer';
interface OnboardingShellProps {
  flow: OnboardingFlow;
  logo: React.ReactNode;
  redirectUrl?: string | null;
}
export function OnboardingShell(t0) {
  const $ = _c(9);
  const {
    flow,
    logo,
    redirectUrl: t1
  } = t0;
  const redirectUrl = t1 === undefined ? null : t1;
  let t2;
  if ($[0] !== logo) {
    t2 = <OnboardingHeader logo={logo} />;
    $[0] = logo;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <main className="flex flex-1 flex-col overflow-hidden"><StepRenderer /></main>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = <div className="relative flex h-screen flex-col bg-black text-white">{t2}{t3}</div>;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== flow || $[6] !== redirectUrl || $[7] !== t4) {
    t5 = <OnboardingProvider flow={flow} redirectUrl={redirectUrl}>{t4}</OnboardingProvider>;
    $[5] = flow;
    $[6] = redirectUrl;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}